/* eslint-disable jsx-a11y/interactive-supports-focus */
/* eslint-disable no-undef */
import React, { useContext } from 'react'
import { MeContext } from 'contexts/me'
import { FireMembership } from 'assets/icons'
import { navigatePayMembership } from 'utils/membershipFunction'
import { trackEvent } from 'analytics/trackFunctions'
import PrimaryButton from './primaryButton'

interface SuspendedMembershipProps {
  isModal?: boolean
  cancelButtonAction?: () => void
  className?: string
  paragraphText?: string | JSX.Element
  bigIcon?: boolean
  eventName?: string
  title?: string
}

const SuspendedMembership = ({
  isModal = false,
  cancelButtonAction = () => null,
  className = '',
  paragraphText = '',
  title = null,
  bigIcon = false,
  eventName = null
}: SuspendedMembershipProps) => {
  const { me } = useContext(MeContext)
  return (
    <div
      className={`w-full bg-white rounded-lg flex flex-col items-center cursor-auto ${
        !isModal && 'p-4'
      } ${className}`}
    >
      <div
        className={`bg-red-100 rounded-full !h-[3.125rem] !w-[3.125rem] flex items-center justify-center ${
          bigIcon && 'h-16 !w-16'
        }`}
      >
        <FireMembership
          className={`h-5 w-5 !stroke-[#F96440] ${
            (bigIcon || isModal) && '!h-6 !w-6'
          }`}
        />
      </div>
      <div>
        <h1
          className={`text-xs text-black font-bold leading-5 text-center mt-3 ${
            bigIcon && '!text-base'
          }`}
        >
          {title || (
            <>
              Tu membresía Wayni<span className='text-green-800'>+</span> está
              suspendida
            </>
          )}
        </h1>
        <p className='text-2xs text-gray-900 sm:max-w-md font-medium leading-[0.875rem] my-2 text-center'>
          {paragraphText}
        </p>
      </div>

      <div
        className={`w-full items-center flex gap-2 ${
          isModal ? 'justify-between' : 'justify-center'
        }`}
      >
        {!!isModal && (
          <PrimaryButton
            className={`${isModal ? 'max-w-full' : 'max-w-[110px]'} mt-4`}
            buttonText='Cancelar'
            outlined
            primaryButtonFunction={cancelButtonAction}
          />
        )}
        <PrimaryButton
          className={`${isModal ? 'max-w-full' : 'max-w-[110px]'} mt-4`}
          buttonText='Pagar'
          primaryButtonFunction={() => {
            navigatePayMembership(me?.profile.identification_number)
            if (eventName) trackEvent({ eventName })
          }}
        />
      </div>
    </div>
  )
}

export default SuspendedMembership
